'use strict';

var empty = null;

module.exports = empty;
//# sourceMappingURL=empty.js.map
